import { CompanyTemplate } from './company'
import { UserTemplate } from './user'


export default [UserTemplate, CompanyTemplate]